// @flow

import glamorous from 'glamorous';

const Header = glamorous.div(({ theme }) => ({
  backgroundColor: theme.color.basis2,
  padding: theme.spacing.small,
  paddingTop: 0,
  color: theme.color.white,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
}));

export default Header;
